import axios from "axios";

export const ACTION_FETCH_TRANSLATIONS_PENDING = 'ACTION_FETCH_TRANSLATIONS_PENDING';
export const ACTION_FETCH_TRANSLATIONS_SUCCESS = 'ACTION_FETCH_TRANSLATIONS_SUCCESS';
export const ACTION_FETCH_TRANSLATIONS_ERROR = 'ACTION_FETCH_TRANSLATIONS_ERROR';

function fetchTranslationsPending() {
    return {
        type: ACTION_FETCH_TRANSLATIONS_PENDING
    }
}

function fetchTranslationsSuccess(translations) {
    return {
        type: ACTION_FETCH_TRANSLATIONS_SUCCESS,
        translations: translations
    }
}

function fetchTranslationsError(translationsError) {
    return {
        type: ACTION_FETCH_TRANSLATIONS_ERROR,
        translationsError: translationsError
    }
}

function fetchTranslations() {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/Localization/GetTranslations';
    return dispatch => {
        dispatch(fetchTranslationsPending());
        axios.get(url, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(fetchTranslationsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(fetchTranslationsError(error));
            })
    }
}

export default fetchTranslations;
